export const curriculumDetailList = [
  {
    id: 0,
    step: '1~3주차',
    titlePc: 'UXUI 디자인의 기초 다지기',
    titleM: 'UXUI 디자인의 기초 다지기',
    desc: '실무에서 바로 쓰는 Figma 스킬과 UXUI 핵심 원리를 익혀, 완성도 높은 디자인을 시작하세요.',
    contents: [
      {
        contentsId: 'contents1-1',
        contentsTitle: 'Figma 완전 정복',
        contentsInner: [
          '프레임, 레이어, 컴포넌트, 오토레이아웃, 프로토타이핑 등 실무 필수 기능 습득',
        ],
      },
      {
        contentsId: 'contents1-2',
        contentsTitle: '시각적 설계 원칙 학습',
        contentsInner: ['UI 요소 배치, 그리드 시스템, 타이포그래피, 컬러 활용까지'],
      },
      {
        contentsId: 'contents1-3',
        contentsTitle: 'UX 사고력 키우기',
        contentsInner: ['더블 다이아몬드 모델을 기반으로 논리적인 UX 설계 방법 익히기'],
      },
    ],
    imgType: '주차별 교육 화면',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section5_img1_ver2_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section5_img1_ver2_m.gif',
  },
  {
    id: 1,
    step: '4~9주차',
    titlePc: '데이터 기반 UX 디자인 실습',
    titleM: '데이터 기반 UX 디자인 실습',
    desc: '도메인별 UX 사례 분석 및 실무 중심 리서치로 문제 해결 능력을 키우세요.',
    contents: [
      {
        contentsId: 'contents2-1',
        contentsTitle: 'UX 다양한 방법론 이론 수업',
        contentsInner: [
          '설문조사, 페르소나, 사용자 여정 지도, 어피니티 다이어그램, A/B 테스트, UT, Eye Tracking, 심층 인터뷰, 서비스 청사진, SWOT, 포지셔닝 맵, 와이어 프레이밍 등',
        ],
      },
      {
        contentsId: 'contents2-2',
        contentsTitle: '실제 유저들의 데이터를 기반으로 서비스 제작',
      },
      {
        contentsId: 'contents2-3',
        contentsTitle: 'UX 사례 소개',
        contentsInner: ['도메인별 소개 (이커머스, 금융, 교통, 교육, OTT, 헬스케어 등)'],
      },
      {
        contentsId: 'contents2-4',
        contentsTitle: '현업에서 쓰는 UX 리서치 방법 완벽 습득',
      },
      {
        contentsId: 'contents2-5',
        contentsTitle: '실제 유저 데이터를 활용한 UX 설계 프로젝트 진행',
      },
      {
        contentsId: 'contents2-6',
        contentsTitle:
          '이커머스, 금융, 교통, 교육, 헬스케어 등 다양한 도메인별 UX 사례 분석 및 적용',
      },
    ],
    imgType: '주차별 교육 화면',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section5_img2_ver2_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section5_img2_ver2_m.gif',
  },
  {
    id: 2,
    step: '10~16주차',
    titlePc: '실무 중심 UI 디자인 & \n반응형 설계',
    titleM: '실무 중심 UI 디자인 & 반응형 설계',
    desc: '디자인 시스템을 직접 구축하고, 다양한 디바이스에 대응하는 반응형 UI를 설계해요',
    contents: [
      {
        contentsId: 'contents3-1',
        contentsTitle: '디자인 시스템 구축부터 활용까지',
        contentsInner: ['컬러 시스템, 타이포그래피, 컴포넌트 설계'],
      },
      {
        contentsId: 'contents3-2',
        contentsTitle: '모바일·웹 반응형 UI 설계',
        contentsInner: ['다양한 화면 크기에 대응하는 실무 설계 기법 실습'],
      },
      {
        contentsId: 'contents3-3',
        contentsTitle: 'UI Kit 제작 및 클론 디자인 프로젝트',
        contentsInner: ['실무에서 요구하는 디자인 역량을 포트폴리오로 완성'],
      },
    ],
    imgType: '주차별 교육 화면',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section5_img3_ver2_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section5_img3_ver2_m.gif',
  },
  {
    id: 3,
    step: '17~21주차',
    titlePc: '맞춤형 포트폴리오 제작 & \n취업 준비',
    titleM: '맞춤형 포트폴리오 제작 & 취업 준비',
    desc: '기획부터 포트폴리오 완성까지, 취업을 위한 모든 준비를 끝내요',
    contents: [
      {
        contentsId: 'contents4-1',
        contentsTitle: '업계에서 인정받는 포트폴리오 제작법 & 차별화 전략 학습',
      },
      {
        contentsId: 'contents4-2',
        contentsTitle: '기업 채용 공고(JD) 분석을 통한 맞춤형 포트폴리오 작성',
      },
      {
        contentsId: 'contents4-3',
        contentsTitle: '포트폴리오 완성 특강 + 현직 디자이너의 1:1 피드백 제공',
      },
    ],
    imgType: '주차별 교육 화면',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section5_img4_ver2_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section5_img4_ver2_m.gif',
  },
]

export const projectSlideList = [
  {
    category: '개인 프로젝트',
    titlePc: 'Figma를 활용한 UXUI 디자인의 기초',
    titleM: 'Figma를 활용한 UXUI \n디자인의 기초',
    contents: [
      {
        contentsId: 'contents1-1',
        contentsIntro: '사용자 경험을 개선하는 디자인 사고력과 \nUI 설계 역량을 키웁니다',
        contentsInnerType: 'custom',
        contentsInner: [
          'UX 문제 해결 프로젝트',
          '기존 제품의 UXUI 문제를 분석하고, \n사용자 경험을 극대화하는 디자인 솔루션을 제시해요',
          'UI Kit & 클론 디자인 프로젝트',
          '디자인 시스템과 UI 구성 요소를 정리하고, \n체계적으로 UI를 설계하는 방법을 익혀요',
        ],
        contentsImgUrlPc:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section6_slide_img1_ver3_pc.png',
        contentsImgUrlM:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section6_slide_img1_ver2_m.png',
      },
    ],
  },
  {
    category: '팀 프로젝트 1',
    titlePc: 'UX 리디자인 프로젝트 - \n사용자의 진짜 니즈를 반영한 디자인 혁신',
    titleM: 'UX 리디자인 프로젝트 - \n사용자의 진짜 니즈를 \n반영한 디자인 혁신',
    contents: [
      {
        contentsId: 'contents3-1',
        contentsIntro:
          '실제 서비스의 UX 문제를 분석하고, \n사용자 중심의 혁신적인 솔루션을 설계해요',
        contentsInner: [
          '다양한 도메인 전문성 이해, UX 설계',
          '사용자 인터뷰를 통한 유저 니즈 이해, 핵심 문제 분석',
          '다양한 연구 방법을 통한 사용자 행동 분석',
        ],
        contentsImgUrlPc:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section6_slide_img2_ver3_pc.png',
        contentsImgUrlM:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section6_slide_img2_ver2_m.png',
      },
    ],
  },
  {
    category: '팀 프로젝트 2',
    titlePc: 'MVP 제작 프로젝트 - ‘0’에서 ‘1’을 \n만들어내는 실전 프로젝트',
    titleM: 'MVP 제작 프로젝트 - \n‘0’에서 ‘1’을 만들어내는 \n실전 프로젝트',
    contents: [
      {
        contentsId: 'contents4-1',
        contentsIntro: 'UX 기획부터 UI 설계, 프로토타입 제작까지! \n하나의 새로운 제품을 완성해요',
        contentsInner: [
          '전략적 포트폴리오 기획/구성',
          '실현 가능성을 고려한 UXUI 설계',
          '프로토타입을 통한 완성도 높은 결과물 입증',
        ],
        contentsImgUrlPc:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section6_slide_img3_ver2_pc.png',
        contentsImgUrlM:
          'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section6_slide_img3_ver2_m.png',
      },
    ],
  },
]

export const projectOutputList = [
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section7_img1_pc.gif',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section7_img1_m.gif',
    title: '국내여행 플랫폼 서비스 Tripik',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section7_img2_pc.gif',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section7_img2_m.gif',
    title: '펫츠잇츠 : 반려동물 맞춤 푸드 분석',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section7_img3_pc.gif',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section7_img3_m.gif',
    title: '10대 청소년 헬스케어 서비스',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section7_img4_pc.gif',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section7_img4_m.gif',
    title: 'OLLA : 등산가이드',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section7_img5_pc.gif',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section7_img5_m.gif',
    title: '중장년 맞춤 구직 서비스',
  },
]

export const classOneSlideList = [
  {
    category: '1회차',
    titlePc: '디엘스의 실무 프로세스와 스토리텔링 기법',
    titleM: '디엘스의 실무 프로세스와 \n스토리텔링 기법',
    contents: [
      {
        contentsId: 'class1-1',
        contentsInner: [
          '디엘스의 디자인 프로세스 소개',
          '사용자 경험을 극대화하는 스토리텔링 기법',
          '사례 연구: 성공적인 UXUI 스토리텔링 사례',
        ],
      },
    ],
  },
  {
    category: '2회차',
    titlePc: '디엘스의 실무 프로세스 응용',
    titleM: '디엘스의 실무 프로세스 응용',
    contents: [
      {
        contentsId: 'class1-2',
        contentsInner: [
          '디자인 프로세스에 애니메이션 적용',
          '애니메이션이 사용자 경험에 미치는 영향',
        ],
      },
    ],
  },
  {
    category: '3회차',
    titlePc: '프론트엔드 개발자의 협업을 통한 UXUI 개선',
    titleM: '프론트엔드 개발자의 \n협업을 통한 UXUI 개선',
    contents: [
      {
        contentsId: 'class1-3',
        contentsInner: [
          '디자이너와 개발자 간의 효과적인 커뮤니케이션',
          '프론트엔드 개발을 고려한 UXUI 개선 방향',
        ],
      },
    ],
  },
]

export const classTwoSlideList = [
  {
    category: 'APP 디자인',
    titlePc: 'APP 디자인 핵심 가이드',
    titleM: 'APP 디자인 핵심 가이드',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section9_slide_img1_ver2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section9_slide_img1_ver2_m.png',
    contents: [
      {
        contentsId: 'class2-1',
        contentsIntro: '모바일 사용자 경험을 극대화하는 UXUI \n설계법을 배워요',
        contentsInner: [
          '브랜드 스토리를 시각적으로 풀어내는 모바일 UI 설계',
          '모바일 디자인의 개성과 독창성을 표현하는 UXUI 전략',
          '모바일에서의 디자인 시스템 활용',
        ],
      },
    ],
  },
  {
    category: 'WEB 디자인',
    titlePc: 'WEB 디자인 실전 기술',
    titleM: 'WEB 디자인 실전 기술',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section9_slide_img2_ver2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section9_slide_img2_ver2_m.png',
    contents: [
      {
        contentsId: 'class2-2',
        contentsIntro: '웹 환경에서 사용자 친화적인 UXUI를 구현하는 \n방법을 익혀요',
        contentsInner: [
          '디자인의 창의적 접근: 웹에서의 독특한 시각적 경험 창출',
          '웹 환경에 최적화된 UXUI 전략',
        ],
      },
    ],
  },
]

export const classThreeDetailList = [
  {
    id: 0,
    step: '1.',
    titlePc: '이론과 실무의 차이로 보는 \n실제 프로젝트 UXUI 디자인 \n프로세스',
    titleM: '이론과 실무의 차이로 보는 \n실제 프로젝트 UXUI 디자인 프로세스',
    desc: '"이론과 실무의 간극: 실제 프로젝트에서 UXUI 디자인이 적용되는 방식"',
    contents: [
      {
        contentsId: 'class3-1',
        contentsInner: [
          '이론과 실무의 차이를 실제 사례로 분석',
          '에이전시 vs 인하우스 UXUI 디자인 프로세스 비교',
          'UXUI 디자이너가 실무에서 직면하는 현실적 문제 해결법',
        ],
      },
    ],
  },
  {
    id: 1,
    step: '2.',
    titlePc: '실제 사례로 살펴보는 실무형 \nUXUI 디자이너가 되는 \n방법',
    titleM: '실제 사례로 살펴보는 \n실무형 UXUI 디자이너가 되는 방법',
    desc: '"실무형 UXUI 디자이너의 성장법: 사례로 보는 필수 역량"',
    contents: [
      {
        contentsId: 'class3-2',
        contentsInner: [
          '기업과 에이전시가 원하는 ‘실무형 UXUI 디자이너’의 조건 ',
          '수치 없는 데이터 기반 UX 설계',
          '주니어 → 시니어 UXUI 디자이너 성장 경로',
        ],
      },
    ],
  },
  {
    id: 2,
    step: '3.',
    titlePc: 'UXUI 디자인 이야기가 아닌 \nUXUI 디자이너를 위한 이야기',
    titleM: 'UXUI 디자인 이야기가 아닌 \nUXUI 디자이너를 위한 이야기',
    desc: '"UXUI 디자이너로 살아남기: 커리어, 성장, 그리고 지속 가능한 디자인"',
    contents: [
      {
        contentsId: 'class3-3',
        contentsInner: [
          '디자이너로서의 지속 가능한 성장 전략',
          'AI 시대에서 UXUI 디자이너의 차별화된 강점',
          '프리랜서, 창업을 고려하는 UXUI 디자이너를 위한 현실적인 조언',
        ],
      },
    ],
  },
]

export const classSupportList = [
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section11_img1_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section11_img1_m.png',
    type: '현직 디자이너 멘토링',
    title: '1:1 밀착 케어, \n실시간 피드백 제공',
    desc: '혼자 고민할 필요 없어요! \n실무 경험이 풍부한 최대 6명의 현직 디자이너가 여러분을 끝까지 서포트합니다.',
    descList: [
      '1:1 맞춤형 피드백 제공 - 실무에서 통하는 UXUI 디자인 피드백',
      '실시간 Q&A 및 실무 가이드 - 막히는 부분은 바로 해결!',
      '포트폴리오 코칭 & 취업 상담 - 취업까지 고려한 개별 컨설팅 지원',
    ],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section11_img2_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section11_img2_m.png',
    type: '무료 기초 강의',
    title: 'UXUI 기초부터 Figma 툴까지, \nVOD 강의 무료 제공',
    desc: '비전공자도 문제없어요! \nUXUI 개념부터 Figma 툴 활용까지, 기초 강의를 무료로 제공합니다.',
    descList: [
      '좋아 보이는 프로덕트의 비밀 - 성공하는 UXUI 디자인의 핵심 요소',
      'UX Discovery 1 - 사용자의 문제를 정의하는 법',
      'Figma 기초 & 응용 - UXUI 디자인 필수 툴 완전 정복',
      'UX Discovery 2 - 사용자 경험을 향상시키는 디자인 방법',
    ],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section11_img3_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section11_img3_m.png',
    type: '그로우 메이트',
    title: '함께 성장하는 스터디 \n& 팀 프로젝트 운영',
    desc: '함께 배우면 더 빠르게 성장할 수 있습니다! \n동료들과 함께 UXUI 디자인을 익혀보세요.',
    descList: [
      '스터디 그룹 운영 - 같은 목표를 가진 사람들과 함께 학습하며 동기 부여',
      '질문 & 답변 커뮤니티 활성화 - 혼자 공부할 때보다 빠르게 성장',
      '선배의 한마디 \n“그로우 메이트의 정보 공유 덕분에 실력 향상을 체감할 수 있었고, 혼자 공부할 때의 어려움도 해소됐어요. 비전공자도 너무 걱정하지 마세요! 같은 목표를 가진 동료들과 함께하면, 끝까지 완주할 수 있으니까요”',
    ],
  },
]

export const careerSupportList = [
  {
    id: 0,
    titlePc: '1. 자기 탐색',
    titleM: '1. 자기 탐색',
    contents: [
      {
        contentsId: 'careerSupport1-1',
        contentsTitle: '취업 특강',
        contentsInner: ['산업 분석, 자기 분석, 취업 전략 도출'],
      },
      {
        contentsId: 'careerSupport1-2',
        contentsTitle: '개별 상담',
        contentsInner: ['진로 탐색, 취업 로드맵 수립, 포트폴리오 작업 방향성 탐색'],
      },
      {
        contentsId: 'careerSupport1-3',
        contentsTitle: '실무 특강',
        contentsInner: ['직무 분석, 채용 동향, 포트폴리오 관련 현직자 특강'],
      },
    ],
  },
  {
    id: 1,
    titlePc: '2. 역량 강화',
    titleM: '2. 역량 강화',
    contents: [
      {
        contentsId: 'careerSupport2-1',
        contentsTitle:
          '이력서/자기소개서 작성 방법 특강 진행 (이력서 양식 및 대기업 합격 자기소개서 샘플 포함)',
      },
      {
        contentsId: 'careerSupport2-2',
        contentsTitle: 'IT 전문 취업 컨설턴트의 포트폴리오 꿀팁 대방출',
      },
      {
        contentsId: 'careerSupport2-3',
        contentsTitle: '도메인 기반 취업 스터디 운영',
      },
    ],
  },
  {
    id: 2,
    titlePc: '3. 수료 후 지속 케어',
    titleM: '3. 수료 후 지속 케어',
    contents: [
      {
        contentsId: 'careerSupport3-1',
        contentsTitle: '교육 과정 수료 이후에도 지속적인 구직활동 현황 체크',
      },
      {
        contentsId: 'careerSupport3-2',
        contentsTitle: '개인 맞춤형 취업지원 제공',
      },
      {
        contentsId: 'careerSupport3-3',
        contentsTitle: '스타트업 인사팀장 출신 코치의 1:1 상담 프로그램 지원',
      },
      {
        contentsId: 'careerSupport3-4',
        contentsTitle: '수료 후 6개월간 이력서 및 포트폴리오 첨삭 제공',
      },
      {
        contentsId: 'careerSupport3-5',
        contentsTitle:
          '수료 후 상시로 진행되는 취업 박람회, 특강, 우선채용 기회 제공 : IT 맞춤형 채용설명회 진행',
      },
      {
        contentsId: 'careerSupport3-6',
        contentsTitle:
          'IT 전 직무 수료생이 모인 ”세렝게티“ 네트워크를 통한 스터디, 프로젝트, IT 취업정보 공유',
      },
    ],
  },
]

export const preBenefitList = [
  {
    title: '프리러닝의 중요성',
    contents: [
      {
        contentsId: '1',
        contentsIntro: '기본 개념 이해',
        contentsInner: [
          '고급 주제에 접근하기 전에 필수적인 기초 지식을 \n쌓아야 합니다. 이는 복잡한 개념을 쉽게 이해하는 데 도움이 됩니다.',
        ],
      },
      {
        contentsId: '2',
        contentsIntro: '학습 속도 향상',
        contentsInner: [
          '기본적인 내용을 미리 숙지하면 교육 과정에서 더 빠르게 진도를 나갈 수 있습니다.',
        ],
      },
      {
        contentsId: '3',
        contentsIntro: '자신감 증진',
        contentsInner: [
          '선행학습을 통해 얻은 지식과 실습 경험은 교육 과정을 따라가는 데 있어 자신감을 높여줄 것입니다.',
        ],
      },
    ],
  },
  {
    title: '프리러닝을 위한 팁',
    contents: [
      {
        contentsId: '1',
        contentsIntro: '정기적인 학습 스케줄',
        contentsInner: ['일주일에 몇 시간씩 공부할지 결정하고, 일정을 \n지키려고 노력하세요.'],
      },
      {
        contentsId: '2',
        contentsIntro: '실습 중심 학습',
        contentsInner: [
          '이론을 배운 후에는 반드시 실습을 통해 적용해보세요. 간단한 웹 페이지를 만들어보는 것부터 시작할 수 있습니다.',
        ],
      },
      {
        contentsId: '3',
        contentsIntro: '의문점 기록',
        contentsInner: [
          '학습하는 동안 생기는 의문점을 기록해두고, \n해결하기 위해 노력하세요. 이 때 블로그를 활용하면 \n좋습니다. 블로그는 단순히 책이나 강의를 정리하는 \n것보다는 내가 공부하면서 막혔던 부분에 대해 \n정리하는 용도로 사용하는 것이 개발 공부를 할 때 \n좋습니다. 프로그래머는 결국 문제를 해결하는 \n사람이니까요.',
        ],
      },
    ],
  },
]

export const benefitSlideList = [
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section15_benefit_img1_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section15_benefit_img1_m.png',
    title: '오프라인 프로젝트 공간 지원',
    desc: '사전 신청자에 한하여 프로젝트를 진행할 수 있는 오프라인 공간을 지원해 드려요',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section15_benefit_img2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section15_benefit_img2_m.png',
    title: '교육 장비 지원',
    desc: '교육 시작 후, 교육 장비가 필요한 인원에 한하여 무료로 장비를 대여해 드려요',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section15_benefit_img3_ver2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section15_benefit_img3_ver2_m.png',
    title: '훈련장려금 지급',
    desc: '매월 최대 81만원의 훈련 지원금을 받을 수 있어요',
    option:
      '*단, 국민취업제도 참여 유형을 포함한 개인의 상황에 따라 \n다를 수 있으며 자세한 사항은 고용 24에서 확인해 주세요.',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section15_benefit_img4_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section15_benefit_img4_m.png',
    title: '교육비 전액 무료',
    desc: '내일배움카드로 1,700만원 상당의 교육을 무료로 들을 수 있어요',
  },
]

export const reviewList = [
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section16_img1_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section16_img1_m.png',
    title: '실무 노하우가 담긴 \n보조강사님의 꼼꼼한 답변 \n덕분에 많은 걸 배울 수 \n있었어요!',
    desc: '스터디 진행 중에, 해결되지 않은 질문들을 모아 주 1회 피그마에 질문을 남겨놓았는데요, \n보조강사님께서 바쁜 일정에도 시간을 내어 꼼꼼히 답변을 달아주셨어요!! 답변은 ‘실무에서는 이와 \n같은 상황에 어떻게 대처하는지’와 같이 실무 노하우가 담긴 세심한 답변을 해주셨고, 관련해 추가로 \n알아두면 좋을 것 같은 꿀팁이나 내용/아티클이 있다면 같이 공유를 해주셨고, \n덕분에 정말 많이 배울 수 있었습니다!!',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section16_img2_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section16_img2_m.png',
    title: 'UX 역량뿐만 아니라, \n협업과 커뮤니케이션 스킬도 \n함께 성장할 수 있었어요!',
    desc: '훈련과정을 통해 UX에 대한 지식을 쌓을 수 있었습니다. 해당 지식을 통해 어떻게 내가 프로젝트를 진행해야 하고, 회사에 입사했을 때에도 어떤 지식을 활용해서 문제 해결을 할 수 있는지에 대해서 알게 된 것 같습니다. 팀별 수업이기 때문에 사람들과 소통하는 것과 동시에 아이디어를 어필하고, 의견을 하나로 모으는 등의 세세한 커뮤니케이션 능력도 조금씩 기를 수 있었던 것 같습니다. 수업 이외에 팀별 활동/개인 활동 시간에 보조강사님들 덕분에 궁금한 점은 바로바로 해결할 수 있고, 수강생들과 함께 지식을 나누고 많이 배워가서 좋았던 것 같습니다',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section16_img3_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section16_img3_m.png',
    title: '높은 강의력과 \n탄탄한 커리큘럼 덕분에 \n큰 성장을 이룰 수 있었어요!',
    desc: '최고의 강의였습니다. 높은 강의력과 탄탄한 커리큘럼, 진심으로 훈련생들을 위해주시는 보조강사님들, \n뒤에서 한명 한명 꼼꼼히 챙겨주시는 매니저님들 무엇 하나 부족하지 않았던 훈련 과정이었습니다. \n6개월이라는 시간동안, 정말 많은 성장을 이룰 수 있었습니다. 매일 9시부터 6시까지 힘들지 않다면 \n거짓말이지만, 그만큼 가치가 있습니다',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section16_img4_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section16_img4_m.png',
    title: '촘촘한 커리큘럼과 실무 스킬 \n덕분에 깊이 있는 디자인 이해를 쌓을 수 있었어요!',
    desc: '긴 시간이 금방 지나갈 정도로 촘촘하고 알찬 수업이었습니다. 단계마다 세심히 계획된 커리큘럼 \n덕분에 디자인에 대한 깊이 있는 이해를 쌓을 수 있었고, 실무에서 적용할 수 있는 유용한 기술들을 \n배울 수 있었습니다. 강사님들의 전문성과 열정 덕분에 동기부여가 되었고, 동료들과의 협업을 통해 \n다양한 관점을 배울 수 있어 유익한 시간이었습니다.',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section16_img5_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section16_img5_m.png',
    title: '처음엔 비전공자로서 \n걱정이 많았지만, \n최고의 선택이었어요!',
    desc: '비전공자로서 걱정과 고민도 많았지만 좋은 강사님들, 보조강사님들, 특강강사님들, 매니저님들, 동기들 덕분에 무사히 수료할 수 있었습니다. 커리큘럼도 탄탄하고, 운영 방식도 효율적이었다고 생각합니다. 지난 4개월, 투자할 만한 가치가 있는 소중한 시간이었어요! 떠나는 게 아쉬울만큼요! 처음에는 그룹 활동을 하고, 줌으로 대화를 하는 게 부담스럽고 긴장도 많이 됐었는데 꾸준히 하다 보니 익숙해졌고 좋은 연습이 된 것 같아요. 많은 수강생들과의 협업을 통해 커뮤니케이션 스킬도 자연스럽게 터득할 수 있었습니다. 올해 제가 한 최고의 선택이었어요!!!',
  },
]

export const ApplySchedule1List = [
  {
    title: '모집기간',
    content: '2025년 02월 24일(월) 오후 2시 ~ \n2025년 03월 29일(토) 오후 11시',
  },
]

export const ApplySchedule2List = [
  {
    title: '서류 합격자 \n발표일',
    content: '지원서 제출 후 7일 내 발표',
  },
]

export const EduScheduleList = [
  {
    title: '개강&OT',
    content: '2025년 03월 31일(월) 오후 2시',
  },
  {
    title: '교육 기간',
    content: '2025년 03월 31일(월) ~ \n2025년 08월 22일(금)',
  },
  {
    title: '교육 시간',
    content: '720시간 / 평일 9시 ~ 18시 \n(점심시간 12시~13시 제외)',
  },
  {
    title: '학습 형태',
    content: '실시간 온라인 교육',
  },
]

export const bootCampFaqTabList = [
  { label: '전체', value: 'all' },
  {
    label: '지원',
    value: 'apply',
  },
  {
    label: '선발',
    value: 'nebeka',
  },
  {
    label: '취업',
    value: 'employment',
  },
  {
    label: '교육운영',
    value: 'edu',
  },
  {
    label: '특전혜택',
    value: 'benefit',
  },
  {
    label: '기타',
    value: 'etc',
  },
]

interface IBootCampFaqList {
  [key: string]: {
    question: string
    answer?: string
    secondAnswer?: string
    externalUrl1?: string
    urlName1?: string
    externalUrl2?: string
    urlName2?: string
    answerList?: string[]
  }[]
}

export const bootCampFaqList: IBootCampFaqList = {
  apply: [
    {
      question: '[지원] 지원 자격이 있나요?',
      answer:
        '국민내일배움카드를 보유하고 있거나 발급 가능하다면 누구든지 지원하실 수 있습니다. 발급 가능 여부는 고용노동부 1350 또는 거주지 관할 고용센터에서 직접 확인해주셔야 합니다. \n국민내일배움카드를 발급받고 교육 기간 동안 주 5일, 매일 약 8시간의 교육 과정에 온전히 참여하실 수 있다면 원칙상 수강할 수 있으나, 직장과 병행해야 해서 정해진 시간에 출석할 수 없고 하루 8시간의 학습 시간을 채울 수 없는 경우 선발에서 제외됨을 알려드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드가 없어도 지원할 수 있나요?',
      answer:
        '지원은 가능합니다. 다만 최종 합격 발표 전까지는 모바일 앱 카드 혹은 실물 카드를 소지하고 있으셔야 합니다. \n모바일 앱 카드의 경우, 신청 당일에 즉시 발급이 가능하지만 오프라인 카드 발급은 최종 수령까지 일주일 이상 소요될 수 있기에 고용노동부 1350을 통해 카드 발급 자격 확인 및 발급 신청을 빠르게 하시는 것을 추천드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드는 반드시 오프라인에서만 발급 받을 수 있나요?',
      answer:
        '국민내일배움카드는 고용24 홈페이지를 통해 신청 가능하며 오프라인과 온라인 모두 발급 받으실 수 있습니다. \n자세한 발급 과정은 아래 링크를 통해 확인 가능합니다.',
      externalUrl1: '/nebeca',
      urlName1: '국민내일배움카드 신청 방법 확인하기 (링크)',
      externalUrl2: '/nebeca/issued',
      urlName2: '국민내일배움카드 모바일 발급 방법 확인하기 (링크)',
    },
    {
      question: '[지원] 비전공자도 지원 가능한가요?',
      answer:
        '네. 지원 가능합니다. 전공과 무관하게 UXUI 디자이너가 되려는 강한 의지와 계획이 있으시면 됩니다. \n다만, 합격 후 5개월 동안 정말 몰입해서 학습을 이어가셔야 합니다. 꾸준한 의지와 학습 습관으로 목표하시는 변화를 만들어내시기 바랍니다.',
    },
    {
      question: '[지원] 다른 부트캠프와 중복 지원 가능한가요?',
      answer:
        '멋쟁이사자처럼이 운영하는 다른 부트캠프와 중복 지원은 불가합니다. 다른 훈련기관이 운영하는 과정에 중복 지원하는 것은 가능합니다. 희망하는 부트캠프에 한해 하나만 지원 가능하므로 신중하게 고민하고 선택해주세요. ',
    },
    {
      question: '[지원] 고용24 수강신청은 언제 할 수 있나요?',
      answer:
        '최종 합격자로 선발된 후, 합격하신 분들께 별도로 안내해 드릴 예정입니다. \n안내를 받으신 후 고용24에서 신청해주시면 됩니다.',
    },
    {
      question: '[지원] 지원서 제출 후 수정 가능한가요?',
      answer: '지원서 수정은 불가능합니다. 항목을 미리 검토하신 후 제출하시기 바랍니다.',
    },
  ],
  nebeka: [
    {
      question: '[선발] 선발 절차는 어떻게 되나요?',
      answer:
        '국민내일배움카드 발급 → 지원서 및 취업적합성 검사 제출 → 최종합격자 발표 → 고용24 수강신청 순으로 진행됩니다. \n국민내일배움카드 발급에 일주일 이상 소요되므로 발급 신청을 먼저 해주시기 바랍니다.',
    },
    {
      question: '[선발] 2차 취업적합성 검사는 무엇인가요?',
      answer:
        '부트캠프 합류에 앞서 UXUI에 대한 기본 이해와 취업에 대한 의지를 확인하고자 하는 누구나 답할 수 있는 간단한 검사입니다.',
    },
    {
      question: '[선발] 합격 확인은 어떻게 하나요?',
      answer:
        '각 단계별로 합격하신 분들께는 E-mail과 SMS로 안내드릴 예정입니다. 발표 일정은 상세페이지를 참고해주세요. \n*발표 일정은 상황에 따라 일부 변경될 수 있습니다.',
    },
  ],
  employment: [
    {
      question: '[취업] 취업 지원 프로그램이 제공되나요?',
      answer:
        '3번의 인턴십 기회 뿐만 아니라, 총 3단계의 취업 지원 프로그램을 통해 최신 채용 트렌드를 반영한 전문적인 이력서 특강 및 피드백을 통한 취업 지원을 받으실 수 있으며 자세한 내용은 위 상세페이지 내에서 확인 가능합니다.',
    },
  ],
  edu: [
    {
      question: '[교육 운영] 교육은 어디서 진행되나요?',
      answer:
        '교육은 오프라인이 아닌, 온라인 라이브로 진행되며 국내에서, 거주 지역에 무관하게 학습할 수 있습니다.',
    },
    {
      question: '[교육 운영] 온라인 수업 출결은 어떻게 진행되나요?',
      answer:
        '두 가지 방법으로 출결이 진행됩니다. \n1. 고용24 앱 설치 후 QR코드 인증(개인 진행) \n2. 줌 모니터링을 통한 매시간 출결 체크(운영진 진행, 줌 화면에 얼굴이 정확히 확인되어야 출석 인정) \n추가로, 수업 참여 중 장소 이동은 불가합니다. 장소 이동 시 출결에 불이익이 발생하니 이점 유의 부탁드립니다.',
    },
    {
      question: '[교육 운영] 수업에 빠질 경우 강의를 다시 볼 수 있나요?',
      answer:
        '본 교육 과정은 학습을 포함한 모든 내용을 영상으로 추가 제공하지 않습니다. 따라서 다음 수업 내용을 잘 따라가기 위해서는 반드시 출석해주셔야 합니다.',
    },
    {
      question: '[교육 운영] 교육 기간 중 쉬는 날은 없나요?',
      answer:
        '교육 기간 내 주말, 공휴일에는 교육을 진행하지 않습니다. 수업 외 일정에 관해서는 오리엔테이션에서 자세하게 안내드릴 예정입니다. 교육기간 동안 온전하게 몰입하시는 것을 권유드립니다.',
    },
    {
      question: '[교육 운영] 해외에서도 참여할 수 있나요?',
      answer:
        'KDT 프로그램의 특성상, 해외에서 수강하는 것은 불가능합니다. 교육 참여 중에 해외로 이동하는 것 역시 불가능합니다.',
    },
  ],
  benefit: [
    {
      question: '[특전 혜택] 합격생에게 제공되는 혜택이 있나요?',
      answerList: [
        '· 3번의 인턴십 기회를 통해 차별화된 실무 경험을 제공합니다.',
        '· 멋쟁이사자처럼 수료생 커뮤니티 활동 기회를 제공합니다.',
        '· 수료 후 정기적으로 진행되는 행사참여 및 네트워킹 기회를 제공합니다. (KDT 수료생에 한함)',
        '· 기초 학습 및 성장을 위한 유료 강의를 제공합니다.',
        '· 이력서 특강 등 개인 맞춤 성장 프로그램을 제공합니다.',
      ],
    },
  ],
  etc: [
    {
      question: '[기타] 훈련장려금을 받을 수 있나요?',
      answer:
        '네. 훈련 장려금은 월 최대 316,000원까지 받으실 수 있으며, 매달 출석률에 따라 차등 지급됩니다. \n국민취업제도에 참여 중인 분들의 경우, 훈련 장려금 외에 추가 훈련 수당을 받으실 수 있으며 1유형에 해당하시는 분들은 500,000원의 훈련수당까지 더해 월 최대 816,000원을 지급받으실 수 있고 2유형에 해당하시는 분들은 284,000원의 훈련수당까지 더해 월 최대 600,000원을 지급받으실 수 있습니다. \n다만, 개인의 상황에 따라 참여 가능한 유형이 다르고 지급받을 수 있는 금액이 다를 수 있기에 반드시 고용24를 통해 확인 및 신청 바랍니다.',
    },
    {
      question: '[기타] 훈련 자비 부담액은 얼마인가요?',
      answer: '본 교육과정은 내일배움카드를 소지하신 분들을 대상으로 전액 무료로 진행됩니다.',
    },
  ],
}
